import TableRowPlaceholder from './TableRowPlaceholder.component';

export default TableRowPlaceholder;